import React from 'react';
import { formatFileSize } from '../utils/formatters';

/**
 * DropZone Component
 * 
 * Drag-and-drop file upload area with:
 * - Visual feedback for drag state
 * - Upload progress indicator
 * - Click to open file picker
 */
const DropZone = ({
  dropZoneRef,
  fileInputRef,
  isDragging,
  isUploading,
  uploadProgress,
  maxFileSize,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  onFileSelect,
  onOpenFilePicker,
}) => {
  return (
    <div 
      ref={dropZoneRef}
      className={`attachments-modal__dropzone ${isDragging ? 'attachments-modal__dropzone--active' : ''} ${isUploading ? 'attachments-modal__dropzone--uploading' : ''}`}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onClick={onOpenFilePicker}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple
        onChange={onFileSelect}
        style={{ display: 'none' }}
      />
      
      {uploadProgress ? (
        <div className="attachments-modal__upload-progress">
          <div className="attachments-modal__upload-filename">{uploadProgress.filename}</div>
          <div className="attachments-modal__upload-bar">
            <div 
              className="attachments-modal__upload-fill"
              style={{ width: `${uploadProgress.progress}%` }}
            />
          </div>
          <span className="attachments-modal__upload-percent">{uploadProgress.progress}%</span>
        </div>
      ) : (
        <>
          <div className="attachments-modal__dropzone-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <div className="attachments-modal__dropzone-text">
            <span className="attachments-modal__dropzone-primary">
              Drop files here or click to upload
            </span>
            <span className="attachments-modal__dropzone-secondary">
              Max {formatFileSize(maxFileSize)} per file
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default DropZone;
